export const USER_PERMISSIONS = {
  create: 'users.create',
} as const;
